export const REPO = "openinary/openinary";
export const REPO_URL = `https://github.com/${REPO}`;

export const DEFAULT_PORT = 3000;

// Used when GitHub is unreachable during scaffolding, so `create` still works offline.
export const FALLBACK_VERSION = "latest";

export const PROJECT_CONFIG_FILE = "openinary.json";

export const HEALTH_TIMEOUT_MS = 90_000;
export const HEALTH_POLL_INTERVAL_MS = 500;

export const GITHUB_API_TIMEOUT_MS = 5_000;
